/* eslint-disable max-lines */
/* eslint-disable no-console */
/* eslint-disable sort-keys */
import { useEffect, useMemo, useCallback, useState } from 'react';
import { useSetFcmToken } from '../../hooks/use-setfcmtoken';
import { useGetNotificationHistory } from '../../hooks/use-getNotificationHistory';
import { useSubscriberId } from '../../hooks/use-getSubcriberId';
import { useBuildVars } from 'mf_core/config';
import { useMarkAsReadNotifications } from '../../hooks/use-markAsReadForNotifications';
import { useGetNotificationUnreadCount } from '../../hooks/use-getNotificationUnreadCount';

export const FCMEnabler = ({
  fcmToken,
  firebaseReady,
  latestChat,
  readIds,
  resetPagination,
  selectedTabKey,
  setChat,
  setFcmtoken,
  setHasMore,
  setHistoryChat,
  setIsLoading,
  setNotificationCount,
  toDate,
}: any) => {
  const setFcmTokentoDb = useSetFcmToken();
  const readStatus = selectedTabKey ? selectedTabKey.toLowerCase() : 'unread';
  const { data: subscriberIdData } = useSubscriberId();
  const markAsDelivered = useMarkAsReadNotifications(toDate);
  const { buildEnvironment } = useBuildVars();
  const [unreadItems, setUnreadItems] = useState<any[]>([]);
  const [allItems, setAllItems] = useState<any[]>([]);
  const [getRefreshNotificationCount, setRefreshNotificationCount] =
    useState<boolean>(false);
  const { data: UnreadCount } = useGetNotificationUnreadCount();
  const { data: NotificationHistoryInfo, isFetched } =
    useGetNotificationHistory(readStatus, toDate);

  useEffect(() => {
    if (isFetched && NotificationHistoryInfo) {
      setHistoryChat(NotificationHistoryInfo);
      setRefreshNotificationCount((prev) => !prev);
    }
  }, [NotificationHistoryInfo, isFetched, setHistoryChat]);

  useEffect(() => {
    if (
      setNotificationCount &&
      UnreadCount &&
      typeof UnreadCount.totalCount === 'number'
    ) {
      setNotificationCount(UnreadCount.totalCount);
    }
  }, [UnreadCount, setNotificationCount]);
  // Reset and update items per tab
  useEffect(() => {
    if (readStatus === 'unread') {
      if (NotificationHistoryInfo) {
        setUnreadItems((prev) => [...prev, ...NotificationHistoryInfo]);
      }
      setHasMore((NotificationHistoryInfo?.length ?? 0) === 10);
      setIsLoading(false);
    } else if (readStatus === 'all') {
      if (NotificationHistoryInfo) {
        setAllItems((prev) => [...prev, ...NotificationHistoryInfo]);
      }
      setHasMore((NotificationHistoryInfo?.length ?? 0) === 10);
      setIsLoading(false);
    }
  }, [
    NotificationHistoryInfo,
    setHasMore,
    setIsLoading,
    readStatus,
    UnreadCount,
  ]);
  useEffect(() => {
    if (isFetched) {
      setIsLoading(true);
    }
  }, [isFetched, setIsLoading]);

  type FirebaseConfig = {
    apiKey: string;
    appId: string;
    authDomain: string;
    messagingSenderId: string;
    projectId: string;
    storageBucket: string;
  };
  const [subscriberId, setSubscriberId] = useState(() => {
    return localStorage.getItem('subscriberid') || null;
  });
  useEffect(() => {
    if (subscriberIdData) {
      const newSubscriberId = subscriberIdData;
      if (newSubscriberId && newSubscriberId !== subscriberId) {
        localStorage.setItem('subscriberid', newSubscriberId);
        setSubscriberId(newSubscriberId);
      }
    }
  }, [subscriberIdData, subscriberId]);
  const firebaseConfig: FirebaseConfig = useMemo(() => {
    return buildEnvironment === 'development' ||
      buildEnvironment === 'stagingx' ||
      buildEnvironment === 'productionbeta'
      ? {
          apiKey: 'AIzaSyD2gPW474Ymmfw45eraB9OvWi2w9DqpiyU',
          appId: '1:259420669198:web:90432edeb5e2e5cf7dc35f',
          authDomain: 'imgcp-369230c31642aca9.firebaseapp.com',
          messagingSenderId: '259420669198',
          projectId: 'imgcp-369230c31642aca9',
          storageBucket: 'imgcp-369230c31642aca9.firebasestorage.com',
        }
      : {
          apiKey: 'AIzaSyBe9EYHwIudbX3tbu6ZxdDg4MrDOagZ_tQ',
          appId: '1:754257395430:web:563d1fa861596ea1aac527',
          authDomain: 'imgcp-8d41e6bed7a49a8e.firebaseapp.com',
          messagingSenderId: '754257395430',
          projectId: 'imgcp-8d41e6bed7a49a8e',
          storageBucket: 'imgcp-8d41e6bed7a49a8e.firebasestorage.app',
        };
  }, [buildEnvironment]);

  const handleSetFcmtoken = useCallback(
    (token: string) => {
      localStorage.setItem('fcmtoken', token);
      setFcmtoken(token);
    },
    [setFcmtoken]
  );
  type ChatMessage = {
    content?: string;
    createdDate?: string;
    data?: {
      content?: string;
      title?: string;
    };
    fcmMessageId?: string;
    messageId?: string;
    title?: string;
  };
  const handleSetChat = useCallback(
    (updatedChats: ChatMessage[]) => {
      setChat(
        updatedChats.map((item: any) => ({
          ...item,
          content: item?.data?.content,
          createdDate: item?.createdDate || new Date().toISOString(),
          isRead: item?.isRead,
          title: item?.data?.title,
        }))
      );
    },
    [setChat]
  );

  // function to map and update the properties of a single chat item
  const updateChatItem = (item: any, readIds: any) => ({
    ...item,
    content: item?.content,
    createdDate: item?.createdDate || new Date().toISOString(),
    notificationId: item?.notificationId,
    title: item?.title,
    // Preserve isRead status from readIds
    isRead: readIds.has(item?.notificationId) ? true : item?.isRead,
  });

  // function to check if a new chat is already in the prevHistoryChat
  const isDuplicate = (newItem: any, prevHistoryChat: any) => {
    return prevHistoryChat.some(
      (oldItem: any) => oldItem.notificationId === newItem.notificationId
    );
  };

  // function to merge newChats with prevHistoryChat, avoiding duplicates
  const mergeChats = (newChats: any, prevHistoryChat: any) => {
    const uniqueChats = newChats.filter(
      (newItem: any) => !isDuplicate(newItem, prevHistoryChat)
    );
    return [...uniqueChats, ...prevHistoryChat];
  };

  const handleSetChatFromHistoryApi = useCallback(
    (updatedChats: ChatMessage[]) => {
      setHistoryChat((prevHistoryChat: any) => {
        const newChats = updatedChats.map((item) =>
          updateChatItem(item, readIds)
        );
        // Merge newChats with prevHistoryChat, avoiding duplicates
        return mergeChats(newChats, prevHistoryChat);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setHistoryChat, readIds]
  );

  const handleIncomingMessage = useCallback(
    (data: any) => {
      const notificationType =
        data?.data?.notificationType || data?.notificationType;
      const title = data?.data?.title || 'Notification';
      const content = data?.data?.content || '';

      // Determine notificationId
      const notificationId =
        data?.data?.notificationId ||
        data?.notificationId ||
        data?.messageId ||
        null;

      // If it's an in-app message → update chat
      if (notificationType === 'inapp') {
        const updatedChat = [...latestChat.current];

        console.log('[FCM RECEIVED - INAPP]', {
          messageId: data?.messageId ?? null,
          fcmMessageId: data?.fcmMessageId ?? null,
          notificationId,
          title,
          content,
          source: data?.source ?? 'fcm-foreground',
          notificationType,
        });

        const isDuplicate = updatedChat.some((item) => {
          return (
            (item.messageId && item.messageId === data.messageId) ||
            (item.fcmMessageId && item.fcmMessageId === data.messageId) ||
            (item.title && item.title === data.data?.title) ||
            (item.content && item.content === data.data?.content)
          );
        });

        if (!isDuplicate) {
          updatedChat.push(data);
          handleSetChat(updatedChat);
        }

        if (notificationId) {
          markAsDelivered.mutate({
            notificationIds: [notificationId],
            notificationStatus: 'delivered',
            subscriberId: subscriberId,
          });
        }

        return;
      }

      // If it's a browser push notification
      if (notificationType === 'push') {
        console.log('[FCM RECEIVED - PUSH]', {
          title,
          content,
          notificationId,
        });

        if (Notification.permission === 'granted') {
          new Notification(title, {
            body: content,
            icon: '/icons/notification-icon.png', // optional icon
          });
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              new Notification(title, {
                body: content,
                icon: '/icons/notification-icon.png',
              });
            }
          });
        }

        if (notificationId) {
          markAsDelivered.mutate({
            notificationIds: [notificationId],
            notificationStatus: 'delivered',
            subscriberId: subscriberId,
          });
        }

        return;
      }
      setRefreshNotificationCount(!getRefreshNotificationCount);
      console.log('[FCM IGNORED] Unknown notification type:', notificationType);
    },
    [
      latestChat,
      handleSetChat,
      markAsDelivered,
      subscriberId,
      getRefreshNotificationCount,
    ]
  );

  const processIncomingMessage = (events: any[]) => {
    if (events && Array.isArray(events)) {
      const updatedChats = [...events];
      events.forEach((event) => {
        if (event) {
          const isDuplicate = updatedChats.some(
            (item) => item?.data?.notificationId === event.notificationId
          );

          if (!isDuplicate) {
            updatedChats.push({
              content: event.content,
              // messageId: event.messageId,
              createdDate: event.createdDate || new Date().toISOString(),
              isRead: event?.isRead,
              notificationId: event?.notificationId,
              title: event.title,
            });
          }
        }
      });
      handleSetChatFromHistoryApi(updatedChats);
    }
  };
  // Only process the correct items for chat/history
  useEffect(() => {
    if (readStatus === 'unread') {
      processIncomingMessage(unreadItems);
    } else if (readStatus === 'all') {
      processIncomingMessage(allItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadItems, allItems, readStatus, isFetched]);
  useEffect(() => {
    if (!firebaseReady) return;

    const firebase = (window as any).firebase;
    if (!firebase) return;

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    const messaging = firebase.messaging();
    (window as any).firebaseMessaging = messaging;

    const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isWKWebView = () => isIOS() && !!(window as any).webkit;

    if (!('serviceWorker' in navigator) || isWKWebView()) {
      console.warn(
        'Service workers not supported or iOS WKWebView detected. Skipping FCM registration.'
      );
      return;
    }

    const setupFCM = () => {
      navigator.serviceWorker
        .register('./app/firebase-messaging-sw.js')
        .then(async (registration) => {
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
            const VAPID_KEY =
              buildEnvironment === 'development' ||
              buildEnvironment === 'stagingx' ||
              buildEnvironment === 'productionbeta'
                ? 'BNdCrafNXKsqW_ABEgEOJJeAqt12ARqCNKi_RwbRmu0jBJIN5HuZNCyxBkfU-4s6wmuNs-NrwpRYgLYoNqO1MMc'
                : 'BLvaALgoVGv1qMxThfOEGPz8IvRnndiHDhu7DxgpNMh2zFWwiTsxz9UU6-ZAmTYM2se77Lv1ogmSBKm5_EBNmnY';

            const token = await messaging.getToken({
              serviceWorkerRegistration: registration,
              vapidKey: VAPID_KEY,
            });

            if (token) {
              handleSetFcmtoken(token);
            }
          }

          messaging.onMessage((payload: any) => {
            handleIncomingMessage(payload);
          });
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    };

    setupFCM();
  }, [
    firebaseReady,
    firebaseConfig,
    handleSetFcmtoken,
    handleSetChat,
    latestChat,
    buildEnvironment,
    handleIncomingMessage,
  ]);

  const registerFCMToken = async () => {
    try {
      const result = localStorage.getItem('okta-token-storage');
      let tokenData;
      if (result !== null) {
        tokenData = JSON.parse(result);
      }

      const token = tokenData?.accessToken?.accessToken;
      if (!token) {
        throw new Error('Failed to acquire access token.');
      }

      const TokenAvailable = localStorage.getItem('fcmtoken');
      const requestBody = {
        fcmToken: TokenAvailable,

        subscriberId: subscriberId,
        deviceType: 'WEB',
      };
      if (TokenAvailable && subscriberId) {
        setFcmTokentoDb.mutate(requestBody, {
          onError: () => {
            // Handle error case
          },
          onSuccess: () => {
            // Handle success case
          },
        });
      }
    } catch (error) {
      console.error('Error registering FCM Token:', error);
    }
  };

  useEffect(() => {
    const registerToken = async () => {
      if (fcmToken) {
        await registerFCMToken();
      }
    };
    registerToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fcmToken, subscriberId]);

  return null;
};
